<p-dialog
    header="Les différents statuts des emails"
    [modal]="true"
    [closable]="true"
    [(visible)]="visible"
    appendTo="body"
    [style]="{ width: '65rem', height: '35rem' }"
    [contentStyle]="{ overflow: 'auto' }">

    <p-table [value]="rows">
        <ng-template pTemplate="header">
            <tr>
                @for (col of columns; track col) {
                    <th scope="col" [style.min-width]="col.width">{{ col.label | translate }}</th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                @for (col of columns; track col) {
                    <td>
                        @if (col.field === 'action') {
                            @for (action of row.action; track action) {
                                <span>{{ action | translate }}</span>
                            }
                        } @else if (col.field === 'statut') {
                            <p-chip [label]="row.statut" [ngClass]="'status-chip ' + row.color"></p-chip>
                        } @else {
                            {{ row[col.field] | translate }}
                        }
                    </td>
                }
            </tr>
        </ng-template>
    </p-table>
</p-dialog>
